import { withPromise } from "../../../exports/core";

/**
 *
 *
 *
 */
export const getPageMergeId = async (): Promise<string> =>
  (await withPromise(otto.tracking.getPageMergeId(), { timeout: 100 }).catch(() => null)) ??
  "unknown";
